module.exports = __webpack_public_path__ + "static/media/screenshot7.e0128c4e.png";